import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
		};
	}
	
	componentDidMount()
	{
		
	}
	
	render()
	{
		return (
			<div className="bg-gray">
				<div className="body">
					<div className="ur-here">
						<a href="javascript:;">首页</a>
						&gt;
						<span>注册新用户</span>
					</div>
					<div className="article">
						<div className="article-title">
							<h1>文章标题文章标题文章标题文章标题</h1>
							<div className="desc">
								发布时间：2022-04-20 &nbsp;&nbsp;
								作者：admin
							</div>
						</div>
						<div className="article-body">
							  <p><b>黑马喷印平台是区别于传统广告加工厂的广告全产业链生态平台，我平台为实现传统广告行业与互联网的结合、加快传统工厂的转型，自2013年开始根据广告市场的变化进行不断的摸索与研发，历经多年时间，打造了一个智能、高效、便捷的广告服务平台。此平台于2021年正式开放于全国广告市场。</b></p><p><b>自创立以来，以“当日下单、次日送达”为服务宗旨，始终践行“高效、创新”的企业价值观，以最优秀的生产团队、最先进的生产模式、最高效的物流解决广告店与传统加工厂之间QQ接单过程中所遇到的繁琐问题，在下单网址可实现客户对所需产品以及其工艺的自主选择，减少沟通、提高效率，24小时接单，解决传统加工厂下单时限问题，为客户提供智能、高效、便捷的服务。</b></p><p><b>我们保证客户可以轻松掌握下单到生产再到物流配送过程中每一个环节的信息，我们的主营业务包括：写真、喷绘、UV、发光字等，如遇产品质量问题或服务问题可及时与加工厂取得联系，若工厂不予处理，您可直接拨打投诉电话025-5229 3992，我们将竭诚为您服务。</b></p>
						</div>
					</div>
					<div className="height-20"></div>
				</div>
			</div>
		);
	}
}

